<template>
  <b-tag :type="statusType" :size="size">{{ statusIcon }} {{ status }}</b-tag>
</template>

<script>
export default {
  name: "LectureStatusBadge",

  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => ["Created", "Started", "Completed"].includes(value),
    },
    size: {
      type: String,
      default: null,
    },
  },

  computed: {
    statusType() {
      const types = {
        Created: "is-light",
        Started: "is-info is-light",
        Completed: "is-success is-light",
      };
      return types[this.status] || "is-light";
    },

    statusIcon() {
      const icons = {
        Created: "📝", // Memo/pencil for Created/Planned
        Started: "🏃", // Hourglass for Started/In progress
        Completed: "✅", // Checkmark for Completed
      };
      return icons[this.status] || "";
    },
  },
};
</script>
